<div class="app-container">
  <suc-nav-bar
    [logo]="logo$ | async"
    (navOpenClose)="navigationOpened = false"
    (navOpenChange)="navigationOpened = !navigationOpened"
    [navigationElement]="navElement"
    [me]="me"
  ></suc-nav-bar>
  <suc-accordion-nav
    #navigation
    class="mobile-hidden-nav"
    [ngClass]="{ 'nav-open': navigationOpened }"
  ></suc-accordion-nav>
  <div class="app-main-outer">
    <div class="app-main-inner">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
